module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "pdf.worker.ac505a301f213a76a459.js");
}
